import { render, staticRenderFns } from "./staffSelect.vue?vue&type=template&id=6d628e61"
import script from "./staffSelect.vue?vue&type=script&lang=js"
export * from "./staffSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports